
import React, { ReactElement } from 'react';
import { useOutletContext } from 'react-router';
import {useMutation} from '@apollo/client';
import {UPDATE_CAMPAIGN} from '../../../utils/api/campaign';
import MarketSelector from '../../buttons/MarketSelector';


const MarketplaceGuard: React.FC<{children: ReactElement}> = ({children}) => {
  const { campaign, setCampaign } = useOutletContext<any>()
  const [updateCampaign] = useMutation(UPDATE_CAMPAIGN);

  const handleChange = async (marketplace: string) => {
    const res = await updateCampaign({
      variables: {id: campaign._id, record: {marketplace}}
    })

    if (res.data && setCampaign) {
      setCampaign(res.data.campaign)
    }
  }

  if (campaign?.marketplace) {
    return children
  }

  return (
    <MarketSelector onChange={handleChange} />
  );
};

export default MarketplaceGuard;

